import { QRCodeCanvas } from 'qrcode.react';
import { Icon } from '../Icon/Icon';

import './AppQRCodeLink.scss';

interface AppQRCodeLinkProps {
    currentUrl: string;
    linkUrlScheme: string;
}

export const AppQRCodeLink = ({ currentUrl, linkUrlScheme }: AppQRCodeLinkProps) => {
    const appUrl = currentUrl.replace(/^https/, linkUrlScheme);
    return (
        <a href={appUrl} className="d-flex flex-column align-items-center">
            <QRCodeCanvas value={currentUrl} size={192} aria-hidden="true" />
            <span className="mt-2">
                <span className="app-qr-code-link__link-icon">
                    <Icon symbol="icon-bell" />
                </span>
                Skapa bevakning i appen
            </span>
        </a>
    );
};
